import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const UsersIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.544 8.978c0-2.402 1.927-4.348 4.304-4.348 2.377 0 4.304 1.946 4.304 4.348 0 2.401-1.927 4.348-4.304 4.348-2.377 0-4.304-1.947-4.304-4.348zm4.304-2.814c-1.538 0-2.785 1.26-2.785 2.814 0 1.553 1.247 2.813 2.785 2.813s2.785-1.26 2.785-2.813c0-1.554-1.247-2.814-2.785-2.814zM5.797 16.395c-1.258 0-2.278 1.03-2.278 2.302v1.215c0 .019.013.035.031.038 4.171.687 8.425.687 12.596 0a.038.038 0 00.031-.038v-1.215c0-1.272-1.02-2.302-2.278-2.302h-.345a.25.25 0 00-.079.012l-.877.29a8.776 8.776 0 01-5.5 0l-.877-.29a.25.25 0 00-.078-.012h-.346zM2 18.697c0-2.12 1.7-3.837 3.797-3.837h.346c.187 0 .372.03.55.089l.876.289a7.27 7.27 0 004.558 0l.877-.29c.177-.058.363-.088.55-.088h.345c2.097 0 3.797 1.718 3.797 3.837v1.215c0 .77-.553 1.428-1.305 1.552a40.202 40.202 0 01-13.085 0A1.568 1.568 0 012 19.912v-1.215z"
        fill="#001533"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.842 3.568A4.278 4.278 0 0114.152 2c2.377 0 4.304 1.947 4.304 4.348 0 2.1-1.475 3.853-3.435 4.259.163-.521.25-1.076.25-1.651v-.032a2.815 2.815 0 001.666-2.576c0-1.554-1.247-2.813-2.785-2.813-.65 0-1.248.224-1.721.601a5.352 5.352 0 00-1.589-.568zm9.852 15.266c-.656.108-1.314.2-1.974.276v-.743c0-.27-.023-.536-.068-.794.6-.07 1.2-.155 1.798-.253a.038.038 0 00.03-.038v-1.215c0-1.272-1.02-2.302-2.278-2.302h-.345a.25.25 0 00-.078.012l-.877.29a8.782 8.782 0 01-.609.176 5.02 5.02 0 00-2.503-.662h-.448c-.243 0-.484.038-.714.11l-.11.035a5.448 5.448 0 001.043-.776 7.272 7.272 0 002.87-.342l.876-.29c.178-.058.363-.088.55-.088h.345C20.3 12.23 22 13.948 22 16.067v1.215c0 .77-.553 1.428-1.306 1.552z"
        fill="#001533"
      />
    </Svg>
  );
};

export default UsersIcon;
